
const YonetimKurulu = () => {
  return (
    <> 
      <div className="row justify-content-center mb-4 header-hero pt-4 pb-4">
        <div className="col-md-10 col-sm-12">
          <h2>Board of Directors</h2>
        </div>
      </div>

      <div className="row justify-content-md-center yonetim">
        <div className="col-md-8 col-sm-12 mt-4 table-responsive">
          <table className="table table-light table-striped-columns table-bordered table-hover mt-4">
            <tbody>
              <tr>
                <td className="py-3 ps-4">Assoc. Prof. Dr. Mustafa ÇALIŞKAN</td>
                <td className="py-3 ps-4">Chairman of The Board</td>
              </tr>
              <tr>
                <td className="py-3 ps-4">Assoc. Prof. Dr. Erkan BİL</td>
                <td className="py-3 ps-4">Deputy Chairman of the Board</td>
              </tr>
              <tr>
                <td className="py-3 ps-4">Ali Haluk KARAKUŞ</td>
                <td className="py-3 ps-4">Member of The Board</td>
              </tr>
              <tr>
                <td className="py-3 ps-4">Sema DOLAŞOĞLU</td>
                <td className="py-3 ps-4">Member of The Board</td>
              </tr>
              <tr>
                <td className="py-3 ps-4">Prof. Dr. Kemalettin AYDIN</td>
                <td className="py-3 ps-4">Member of The Board</td>
              </tr>
              <tr>
                <td className="py-3 ps-4">Prof. Dr. Murat BALCI</td>
                <td className="py-3 ps-4">Member of The Board</td>
              </tr>
              <tr>
                <td className="py-3 ps-4">Turgut ŞENOL</td>
                <td className="py-3 ps-4">Member of The Board and General Manager</td>
              </tr>
              </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default YonetimKurulu;
